const version = '/api/v1/'
export default {
    "version": version,
    "/signIn": "agent/user/signin",
    "/updPwd": "agent/user/updatePassword",
    "/sendPhoneCode": "agent/user/sendPhoneCode",
    "/resetPwd": "agent/user/forgetPassword",
    "/getCaptcha": "agent/user/getCaptcha",
    "/getStsAccess": "aliyun/oss/stsAccessForWeb",                        // 上传获取临时token
    "/getCurrentResource": "agent/resource/currentOperateResource",
    "/getRoleResourceMap": "agent/resource/getRoleResourceMap",
    "/getCurrentOperateResource": "agent/resource/currentOperateResource",
    "/getInvoiceList": "agent/invoice/getInvoiceList",
    "/getAgentAuthTree": "agent/resource/agentAuthTree",
    "/getCompanyAuthTree": "agent/resource/companyAuthTree",
    "/getIndustryList": "invoice/company/industry/list",
    "/getAreaList": "agent/findAreaList",
    "/searchCompany": "invoice/company/tianyanchaSearch",                               // 输入公司名称自动关联税号
    "/homeStatistics": "workbench/statistics",
    "/getCurrentUserInfo": "agent/user/currentUserInfo",                        // 当前用户信息

    "/getMenuTree": "agent/resource/tree",                                      // 所有资源树
    "/getLevelList": "agent/level/list",                                        // 代理商等级列表
    "/createLevel": "agent/level/create",                                       // 添加代理商等级
    "/updateLevel": "agent/level/update",                                       // 编辑代理商等级
    "/deleteLevel": "agent/level/delete",                                       // 删除代理商等级
    "/activatedLevel": "agent/level/activated",                                 // 启用禁用代理商等级

    "/judgeCustomerPhone": "customer/phone/exist",                              // 判断客户手机号是否存在
    "/getCustomerList": "customer/pageList",                                    // 分页查询客户列表
    "/getCustomerDetail": "customer/findById",                                  // 获取客户详情
    "/createCustomer": "customer/create",                                       // 添加客户
    "/updateCustomer": "customer/update",                                       // 编辑客户
    "/enableCustomer": "customer/enable",                                       // 启用/禁用客户
    "/removeCustomer": "customer/remove",                                       // 删除客户
    "/exportCustomer": "customer/export",                                       // 导出客户
    "/exportCustomerStatus": "customer/export/status",                          // 导出客户状态
    "/getCurrentAgentCertificateTime": "agent/getCurrentAgentCertificateTime",  // 获取代理商有效时间

    "/findProjectSettings": "agent/findProjectSettings",                        // 查询代理商项目设置
    "/saveProjectSettings": "agent/saveProjectSettings",                        // 保存代理商项目设置

    "/findRecord": "agent/findRecord",                                          // 获取记录列表(账户余额列表)
    "/findStock": "agent/findStock",                                            // 获取充值次数
    "/recharge": "agent/recharge",                                              // 充值--账户余额
    "/agentFullNumber": "agent/fullNumber",                                     // 充值--代理商给代理商充值
    "/fullNumber": "customer/fullNumber",                                       // 充值--代理商给客户充值
    "/fullRecordList": "customer/fullRecordList",                               // 充值记录

    "/getAgentDetail": "agent/findById",                                        // 获取记录列表(代理商管理)
    "/getCompanyDetail": "invoice/company/detail",                              // 获取详情
    "/getAgentList": "agent/pageList",                                          // 获取列表(代理商管理)
    "/createAgent": "agent/create",                                             // 添加代理商
    "/updateAgent": "agent/update",                                             // 编辑代理商
    "/enableAgent": "agent/enable",                                             // 启用/禁用代理商
    "/removeAgent": "agent/remove",                                             // 删除代理商
    "/getAgentOption": "agent/getAgentOption",                                  // 直属代理下拉列表
    
    "/exportRecord": "agent/exportRecord",                                      // 导出账户余额记录
    "/exportRecordStatus": "agent/exportRecord/status",                         // 导出账户余额记录状态
    "/getDirectlyList": "customer/getDirectlyList",                             // 获取当前代理下的直属代理商列表   
    "/changeAgent": "customer/changeAgent",                                     // 变更代理商

}


// WEBPACK FOOTER //
// ./src/utils/http/apis.js